<template>
  <div class="w-full h-full zhongqiu-bg-color">
    <div class="zhongqiu">
      <div class="absolute top-0 left-0 w-full h-full flex overflow-hidden">
        <Star class="w-full h-full" />
      </div>
      <img
        src="./assets/zhongqiu/knot-left.svg"
        class="show-pc absolute top-0 left-0 w-12 h-full p-2 select-none"
      />
      <img
        src="./assets/zhongqiu/knot-right.svg"
        class="show-pc absolute bottom-0 right-0 w-12 p-2 select-none"
      />
      <img src="./assets/zhongqiu/light.png" class="absolute -top-10 right-2 w-16 select-none" />
      <img
        src="./assets/zhongqiu/light-sm.png"
        class="show-pc absolute -top-3 right-14 w-16 select-none"
      />
      <img
        src="./assets/zhongqiu/tree.png"
        class="show-pc absolute bottom-0 right-20 w-16 select-none"
      />
      <img
        src="./assets/zhongqiu/rabbit.png"
        class="show-pc absolute bottom-0 right-40 w-24 select-none"
      />
      <img
        src="./assets/zhongqiu/rabbit.png"
        class="show-mb absolute bottom-0 left-0 w-16 mb-rotate select-none"
      />
      <img
        src="./assets/zhongqiu/moon.png"
        class="show-pc absolute -top-10 left-8 w-20 select-none"
      />
      <img
        src="./assets/zhongqiu/cloud-xl.png"
        class="show-pc absolute top-0 left-24 w-16 select-none"
      />
      <img
        src="./assets/zhongqiu/cloud-md.png"
        class="show-pc absolute top-6 left-14 w-10 select-none"
      />
      <img
        src="./assets/zhongqiu/cloud-sm.png"
        class="show-pc absolute top-4 left-6 w-6 select-none"
      />
      <img
        src="./assets/zhongqiu/tree-md.png"
        class="show-mb absolute bottom-0 right-0 w-10 select-none"
      />
    </div>
    <div class="show-pc h-full">
      <LoadingControl v-if="loading" styleType="zhongqiu-bsload" class="w-full" />
      <div v-else class="h-full w-full relative">
        <div class="flex items-center justify-center h-full">
          <EnterIcon class="w-12" :disabled="disabledEnter" color="#FFF095" />
          <span v-if="portalView" class="font-bold text-sm zhongqiu-enter">Back</span>
          <span
            v-else
            :class="[
              'font-bold text-sm zhongqiu-enter select-none',
              disabledEnter ? 'disabled' : ''
            ]"
            >继续</span
          >
        </div>
      </div>
    </div>
    <div class="show-mb flex items-center justify-between h-full w-full relative">
      <div class="flex-1" @click.stop="$emit('menu')" @touchstart.stop>
        <MenuIcom class="mx-auto" activeColor="#FFF095" color="#A2A985" />
      </div>
      <div class="flex-2 h-full rounded-md flex items-center">
        <LoadingControl v-if="loading" class="mx-auto" styleType="zhongqiu-bsload" />
        <EnterIcon
          v-else
          class="w-12 bg-transparent mx-auto"
          color="#FFF095"
          :disabled="disabledEnter"
        />
      </div>
      <div class="flex-1 w-full" @click.stop="$emit('setting')">
        <v-popover class="w-full" trigger="click" :open.sync="popoverVisible">
          <SettingIcon
            class="mx-auto"
            :visible="popoverVisible"
            activeColor="#FFF095"
            color="#A2A985"
          />
          <template #popover>
            <div
              class="w-20 text-center active:bg-gray-400 enter text-lg font-medium"
              @click="$emit('relearn')"
            >
              重新学习
            </div>
          </template>
        </v-popover>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import MenuIcom from '../assets/MenuIcon.vue';
import SettingIcon from '../assets/SettingIcon.vue';
import LoadingControl from '../assets/LoadingControl.vue';
import EnterIcon from '../assets/EnterIcon.vue';
import Star from './assets/StarBg.vue';
@Component({
  components: {
    MenuIcom,
    SettingIcon,
    LoadingControl,
    EnterIcon,
    Star
  }
})
export default class ZhongQiu extends Vue {
  @Prop({ type: Boolean}) loading: boolean;
  @Prop({ type: String}) customText: string;
  @Prop({ type: Boolean}) disabledEnter: boolean;
  @Prop({ type: Boolean}) popoverVisible: boolean;
  
  get portalView() {
    const portalSequence = this.$store.state.common.portalSequence;
    return portalSequence[portalSequence.length - 1];
  }
  transitPopoverVisible = false
  mounted() {
    this.transitPopoverVisible = this.popoverVisible
  }

  @Watch('_popoverVisible')
  popoverVisibleChange() {
    this.$emit('update:popoverVisible', this.transitPopoverVisible)
  }
  
}
</script>
<style scoped>
.show-pc {
  @apply hidden md:flex;
}

.show-mb {
  @apply flex md:hidden;
}

.zhongqiu-enter {
  color: #fff095;
}

.flex-2 {
  flex: 2;
}

.disabled {
  color: #9faad2;
}

.zhongqiu-bg-color {
  background-image: linear-gradient(90deg, #174478, #182a50);
}

.mb-rotate {
  transform: rotateY(180deg);
}
</style>
